
let table = {
    /* userList */
    account: '账号',
    name: '姓名',
    enName: '姓名（英文）',
    cnName: '姓名（中文）',
    contact: '联系方式',
    email: '邮箱地址',
    leverage: '账户杠杆',
    opentime: '开户时间',
    opendate: '开户日期',
    note: '备注',
    operate: '操作',
    /* accountList */
    username: '用户名',
    role: '角色',
    superior: '上级',
    regtime: '注册时间',
    lasttime: '上次登录时间',
    /* clientList */
    countAcc: '账户数量',
    deposit: '入金',
    withdraw: '出金',
    netdeposit: '净入金',
    balance: '余额',
    commission: '佣金收入',
    equity: '净值',
    /* positionReport */
    ticket: '订单号',
    positionOpentime: '开仓时间',
    type: '类型',
    symbol: '品种',
    openprice: '开仓价位',
    stoploss: '止损',
    topprofit: '止盈',
    commiss: '佣金',
    swaps: '利息',
    profit: '盈亏',
    regAddress: '注册地址',
    mt4Bala: '余额',
    /* userGroupSetting */
    groupMana: '用户组管理列表',
    groupName: '用户组名',
    userAuth: '用户权限',
    closeTime: '平仓时间',
    orderId: '佣金单号',
    accountId: '代理账号',
    tradingAccount: '交易账号',
    createTime: '返佣时间',
    clientGroup: '客户组别'
}

export default table;




































// WEBPACK FOOTER //
// ./src/i18n/chinese/table.js